import ARS from './ARS';
import AWG from './AWG';
import BBD from './BBD';
import BMD from './BMD';
import BOB from './BOB';
import BRL from './BRL';
import BSD from './BSD';
import BZD from './BZD';
import CAD from './CAD';
import CLP from './CLP';
import COP from './COP';
import CRC from './CRC';
import CUC from './CUC';
import CUP from './CUP';
import DOP from './DOP';
import FKP from './FKP';
import GTQ from './GTQ';
import GYD from './GYD';
import HNL from './HNL';
import HTG from './HTG';
import JMD from './JMD';
import KYD from './KYD';
import MXN from './MXN';
import NIO from './NIO';
import PAB from './PAB';
import PEN from './PEN';
import PYG from './PYG';
import SRD from './SRD';
import SVC from './SVC';
import TND from './TND';
import TTD from './TTD';
import UGX from './UGX';
import USD from './USD';
import UYU from './UYU';
import VES from './VES';
import XCD from './XCD';

export const AMERICA_CURRENCIES = {
    [ARS.codeNumeric]: ARS,
    [AWG.codeNumeric]: AWG,
    [BBD.codeNumeric]: BBD,
    [BMD.codeNumeric]: BMD,
    [BOB.codeNumeric]: BOB,
    [BRL.codeNumeric]: BRL,
    [BSD.codeNumeric]: BSD,
    [BZD.codeNumeric]: BZD,
    [CAD.codeNumeric]: CAD,
    [CLP.codeNumeric]: CLP,
    [COP.codeNumeric]: COP,
    [CRC.codeNumeric]: CRC,
    [CUC.codeNumeric]: CUC,
    [CUP.codeNumeric]: CUP,
    [DOP.codeNumeric]: DOP,
    [FKP.codeNumeric]: FKP,
    [GTQ.codeNumeric]: GTQ,
    [GYD.codeNumeric]: GYD,
    [HNL.codeNumeric]: HNL,
    [HTG.codeNumeric]: HTG,
    [JMD.codeNumeric]: JMD,
    [KYD.codeNumeric]: KYD,
    [MXN.codeNumeric]: MXN,
    [NIO.codeNumeric]: NIO,
    [PAB.codeNumeric]: PAB,
    [PEN.codeNumeric]: PEN,
    [PYG.codeNumeric]: PYG,
    [SRD.codeNumeric]: SRD,
    [SVC.codeNumeric]: SVC,
    [TND.codeNumeric]: TND,
    [TTD.codeNumeric]: TTD,
    [UGX.codeNumeric]: UGX,
    [USD.codeNumeric]: USD,
    [UYU.codeNumeric]: UYU,
    [VES.codeNumeric]: VES,
    [XCD.codeNumeric]: XCD
};
